import { useI18n } from '../i18n';
import { mySeatInfo, myScore, opponentScore, opponentSeat, type MatchMachineState } from '../match/machine';

/**
 * 比分板。
 * ★ 只顯示「名字 + 已結算的分數 + 連線指示」。
 *   對手區塊**沒有**任何「他出手了沒」的欄位 —— 這是刻意的，見 machine.ts 檔頭。
 */
export function ScoreBoard({ state }: { state: MatchMachineState }) {
  const { t } = useI18n();
  const me = mySeatInfo(state);
  const opp = opponentSeat(state);

  return (
    <section className="scoreboard" aria-label={t('match.score')}>
      <div className="scoreboard__side">
        <span className="scoreboard__name">{me?.display_name ?? t('match.you')}</span>
        <span className="scoreboard__score">{myScore(state)}</span>
        <span className="faint">{t('match.you')}</span>
      </div>

      <div className="scoreboard__sep" aria-hidden="true">
        vs
      </div>

      <div className="scoreboard__side scoreboard__side--right">
        <span className="scoreboard__name">{opp?.display_name ?? t('match.opponent')}</span>
        <span className="scoreboard__score">{opponentScore(state)}</span>
        <span className="faint">
          {opp?.kind === 'ai' ? 'AI' : t('match.opponent')}
          {opp && !opp.connected ? ' · ⚠︎' : ''}
        </span>
      </div>
    </section>
  );
}
